/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import { useTranslation } from 'react-i18next';

import { Radio, Shimmer, Text } from '@pukka/ui-components';
import { twMerge } from 'tailwind-merge';
import { useSnapshot } from 'valtio';

import { BrandsNoData } from '../BrandsNoData';

import { BrandsAssignState, isEmpty } from './BrandsAssign.state';

function LoadingRows() {
  return Array.from({ length: 3 }, (_, i) => (
    <div key={i}>
      <div className="flex h-16 items-center px-4">
        <Shimmer size="lg" />
      </div>
      <hr />
    </div>
  ));
}

function ParentBrandSelector({ state = BrandsAssignState }) {
  const { t } = useTranslation('library');

  const { selectedParent, isLoadingList, filteredParentList, searchFilter } = useSnapshot(state);
  const { setSelectedParent } = state;

  const isEmptyList = isEmpty('parent', state);

  const isFilteredListEmpty = filteredParentList?.length === 0;

  return (
    <div data-testid="parent-brand-selector">
      {isEmptyList && (
        <BrandsNoData
          title={t('brands.notListedYet.title', { subject: 'principal' })}
          description={t('brands.notListedYet.description', { subject: 'principal' })}
        />
      )}
      {!isEmptyList &&
        filteredParentList?.map((prnt) => {
          const isBrandUnprincipal = selectedParent!.id === null && prnt.id === -1;
          const selected = isBrandUnprincipal || selectedParent!.id === prnt.id;

          const handleSelectParent = () => {
            setSelectedParent({ id: prnt.id, name: prnt.name });
          };

          return (
            <div key={prnt.id}>
              <div
                onClick={handleSelectParent}
                className={twMerge(
                  'flex h-16 cursor-pointer items-center justify-between gap-2 rounded-md px-4 ',
                  selected ? 'bg-light-blue-50' : 'hover:bg-neutral-50',
                )}
              >
                <Text as="label" variant="subtitle-2" className="truncate" htmlFor={prnt.name}>
                  {prnt.id === -1 ? t('brands.assignModal.noPrincipal') : prnt.name}
                </Text>
                <Radio id={prnt.name} size="lg" checked={selected} onChange={handleSelectParent} />
              </div>
              <hr />
            </div>
          );
        })}
      {!isEmptyList && isFilteredListEmpty && searchFilter && (
        <BrandsNoData
          title={t('brands.noKeywordFound.title', { keyword: searchFilter })}
          description={t('brands.noKeywordFound.description')}
        />
      )}
      {isLoadingList && <LoadingRows />}
    </div>
  );
}

export { ParentBrandSelector };
